export default {
  serverURI: process.env.VUE_APP_API_URL,
  webPortalURL: process.env.VUE_APP_WEB_PORTAL_URL,
};
